import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import training from './modules/training';
import module from './modules/module';
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        training,
        module,
    },

    plugins: [createPersistedState()]
})